import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import Navbar from "@/components/marketing/Navbar.jsx";
import Footer from "@/components/marketing/Footer.jsx";
import api from "@/lib/api";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const [cycle, setCycle] = useState("monthly");

  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <section className="pt-16 pb-10 text-center bg-mesh">
        <div className="text-xs uppercase tracking-widest font-semibold text-brand-purple">Pricing</div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-navy">Premium voice writing.<br />Indian prices.</h1>
        <div className="mt-8 inline-flex items-center gap-1 bg-white border border-brand-borderc rounded-full p-1">
          <button data-testid="pricing-cycle-monthly" onClick={() => setCycle("monthly")} className={`px-4 py-1.5 rounded-full text-sm font-medium ${cycle === "monthly" ? "bg-gradient-primary text-white" : "text-brand-text"}`}>Monthly</button>
          <button data-testid="pricing-cycle-yearly" onClick={() => setCycle("yearly")} className={`px-4 py-1.5 rounded-full text-sm font-medium ${cycle === "yearly" ? "bg-gradient-primary text-white" : "text-brand-text"}`}>Yearly · save more</button>
        </div>
      </section>
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.map((p) => {
            const price = p.id === "free" ? 0 : cycle === "yearly" ? p.yearly_inr : p.price_inr;
            const featured = p.popular;
            return (
              <div key={p.id} className={`relative rounded-3xl p-7 ${featured ? "bg-gradient-primary text-white shadow-glow-purple" : "bg-white border border-brand-borderc"}`}>
                {featured && <span className="absolute top-5 right-5 text-[10px] uppercase tracking-widest font-bold bg-white/20 text-white px-2.5 py-1 rounded-full">Most popular</span>}
                <div className={`text-sm font-semibold ${featured ? "text-white/80" : "text-brand-muted"}`}>{p.name}</div>
                <div className="mt-2 flex items-baseline gap-1">
                  <span className="text-4xl font-bold">₹{price.toLocaleString()}</span>
                  <span className={`text-sm ${featured ? "text-white/80" : "text-brand-muted"}`}>/{cycle === "yearly" ? "yr" : "mo"}</span>
                </div>
                <ul className="mt-5 space-y-2 text-sm">
                  {(p.features || []).map((f) => (
                    <li key={f} className="flex gap-2"><Check className={`w-4 h-4 mt-0.5 ${featured ? "text-white" : "text-brand-purple"}`} />{f}</li>
                  ))}
                </ul>
                <Link
                  to={p.id === "free" ? "/signup" : "/signup"}
                  className={`mt-7 block text-center rounded-full px-6 py-3 font-semibold transition ${
                    featured ? "bg-white text-brand-navy hover:bg-white/90" : "btn-primary-gradient"
                  }`}
                >
                  {p.cta_label || (p.id === "free" ? "Start free" : `Get ${p.name}`)}
                </Link>
              </div>
            );
          })}
        </div>
      </section>
      <Footer />
    </div>
  );
}
